<template>
  <div id="center-1">
    <div class="first">
      <div class="word">总营业额</div>
      <div class="sum-num">
        <div
          :class="[item == ',' || item == '.' ? 'color-bg' : 'fill-bg']"
          v-for="(item, index) in showList"
          :key="index"
        >
          <span class="num-clor">
            {{ item }}
          </span>
        </div>
      </div>
      <div class="word">元</div>
    </div>
    <div class="row">
      <!-- 设备总数 -->
      <div class="row-item">
        <div class="num">{{ objData.bevChargingCount }}</div>
        <div class="tip">设备总数(台)</div>
        <div class="img">
          <img src="../../assets/pgzl-device-bg.png" alt="" />
        </div>
      </div>
      <!-- 端口总数 -->
      <div class="row-item">
        <div class="num">{{ objData.bevSocketCount }}</div>
        <div class="tip">端口总数(个)</div>
        <div class="img">
          <img src="../../assets/pgzl-socket-bg-2.png" alt="" />
        </div>
      </div>
      <!-- 用电总度数 -->
      <div class="row-item">
        <div class="num">{{ objData.bevTotalElectricity }}</div>
        <div class="tip">用电总度数(度)</div>
        <div class="img">
          <img src="../../assets/pgzl-meter-bg.png" alt="" />
        </div>
      </div>
      <!-- 覆盖城市 -->
      <div class="row-item">
        <div class="num">{{ objData.bevCommunityTotal }}</div>
        <div class="tip">接入社区(个)</div>
        <div class="img">
          <img src="../../assets/pgzl-city-bg.png" alt="" />
        </div>
      </div>
      <!-- 今日订单数 -->
      <div class="row-item">
        <div class="num">{{ objData.bevOrderCountSum }}</div>
        <div class="tip">订单总数(个)</div>
        <div class="img">
          <img src="../../assets/pgzl-order-bg.png" alt="" />
        </div>
      </div>
      <!-- 用户总数 -->
      <div class="row-item">
        <div class="num">{{ objData.bevMemberCount }}</div>
        <div class="tip">用户总数(人)</div>
        <div class="img">
          <img src="../../assets/pgzl-user-bg.png" alt="" />
        </div>
      </div>

      <!-- 用户总数 -->
      <div class="row-item" v-if="regionId == ''">
        <div class="num">{{ objData.rechargeAmount==null?0 :objData.rechargeAmount}}</div>
        <div class="tip">充值金额(元)</div>
        <div class="img">
          <img src="../../assets/pgzl-turnover-2.png" alt="" />
        </div>
      </div>
      <!-- 今日营业额 -->
      <div class="row-item">
        <div class="num">
          {{ (objData.bevTotalTurnover / objData.bevOrderCountSum).toFixed(2) }}
        </div>
        <div class="tip">客单价(元)</div>
        <div class="img">
          <img src="../../assets/pgzl-price.png" alt="" />
        </div>
      </div>
    </div>
    <div class="row-flex">
      <div>
        <!-- <leftPie :souceDataName="souceDataLeftName" :souceDataValue="souceDataLeftValue"></leftPie> -->
        <div
          id="chartLeft"
          ref="mainLeft"
          style="width: 100%; height: 230px"
        ></div>
      </div>
      <div>
        <!-- <rightPie :souceDataName="souceDataRightName" :souceDataValue="souceDataRightValue"></rightPie> -->
        <div
          id="chartRight"
          ref="mainRight"
          style="width: 100%; height: 230px"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { timerSeter } from "@/utils";
import leftPie from "./pie-center/left-pie.vue";
import rightPie from "./pie-center/right-pie.vue";
export default {
  data() {
    return {
      timer: null,
      showList: [],
      totalTurnover: "", //总营业额
      totalElectricity: "", //总用电量
      chargingCount: "", //设备总数
      socketCount: "", //端口总数
      regionCount: "", //覆盖城市数
      memberCount: "", //用户总数
      orderCount: "", //今日订单总数
      orderAmount: "", //今日总营业额
      objData: {},
      // 饼图
      echartAreaLeft: null,
      echartAreaRight: null,
      souceDataLeftName: [],
      souceDataLeftValue: [],
      souceDataRightName: [],
      souceDataRightValue: [],
    };
  },
  props: {
    // objData: {
    //   type: Object,
    //   default: "",
    // },
    regionId: "",
  },
  components: {
    // leftPie,
    // rightPie
  },
  created() {
    this.timer = setInterval(() => {
      // setTimeout(this.getSouceData(), 0);
    }, 1000 * 10);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    this.init();
    this.getoption2Dataleft();
    this.getoption2DataRight();
    this.getTimeData();
    // this.formatNum();
  },
  methods: {
    formatNum(num) {
      let digNum = String(this.objData.bevTotalTurnover).replace(
        /(\d{1,3})(?=(\d{3})+(?:$|\.))/g,
        "$1,"
      );
      this.showList = digNum.toString().split("");
      // console.log("00000", this.showList);
    },
    init() {
      // debugger
      this.echartAreaLeft = this.$echarts.init(this.$refs.mainLeft);
      this.echartAreaRight = this.$echarts.init(this.$refs.mainRight);
    },
    getSouceData() {
      this.getoption2Dataleft();
      this.getoption2DataRight();
      this.getTimeData();
    },
    // 获取总营业额、设备总数、端口总数、用电总数等数据
    getTimeData() {
      this.$http({
        url: this.$http.adornUrl(
          "/admin/api/realTime/getRealTimeBasicDataByStatRegionBusiData"
        ),
        method: "get",
        params: this.$http.adornParams({
          findType: "0",
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        // debugger;
        if (data.code == 0) {
          this.objData = data.data;
          this.formatNum(this.objData.bevTotalTurnover);
        }
      });
    },
    // 饼图突出显示的定时器
    pieIntervalLeft(count) {
      setInterval(() => {
        this.echartAreaLeft.dispatchAction({
          type: "downplay",
          seriesIndex: [0, 1],
        });
        this.echartAreaLeft.dispatchAction({
          type: "highlight",
          seriesIndex: [0, 1],
          dataIndex: count % 6,
        });
        count++;
      }, 1000);
    },
    pieIntervalRight(count) {
      setInterval(() => {
        this.echartAreaRight.dispatchAction({
          type: "downplay",
          seriesIndex: [0, 1],
        });
        this.echartAreaRight.dispatchAction({
          type: "highlight",
          seriesIndex: [0, 1],
          dataIndex: count % 5,
        });
        count++;
      }, 1000);
    },

    getTwoEchartsData() {
      this.getoption2Dataleft();
      this.getoption2DataRight();
    },
    // 组件2的数据源 近7日订单充电时长饼图数据
    getoption2Dataleft() {
      // debugger
      this.souceDataLeftName = [];
      this.souceDataLeftValue = [];
      this.$http({
        url: this.$http.adornUrl("/admin/api/realTime/getChargingTime"),
        method: "get",
        params: this.$http.adornParams({
          findType: 0,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        if (data.code == 0) {
          data.data.keys.forEach((item, index) => {
            var obj = {};
            obj.name = item;
            obj.value = data.data.values1[index];
            this.souceDataLeftName.push(obj);
          });
          data.data.values1.forEach((item, index) => {
            console.log(item, "000000是不是0");
            var obj = {};
            obj.value = item;
            obj.name = "";
            this.souceDataLeftValue.push(obj);
          });
          // setTimeout(()=>{
          //   this.updatedChartLeft()
          // },1500)
          this.updatedChartLeft();
        }
      });
    },
    // 组件2的数据源 近7日订单最大功率饼图数据
    getoption2DataRight() {
      this.souceDataRightName = [];
      this.souceDataRightValue = [];
      this.$http({
        url: this.$http.adornUrl("/admin/api/realTime/getChargingMaxPower"),
        method: "get",
        params: this.$http.adornParams({
          findType: 0,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        if (data.code == 0) {
          data.data.keys.forEach((item, index) => {
            var obj = {};
            obj.name = item;
            obj.value = data.data.values1[index];
            this.souceDataRightName.push(obj);
          });
          data.data.values1.forEach((item, index) => {
            console.log(item, "000000是不是0");
            var obj = {};
            obj.value = item;
            obj.name = "";
            this.souceDataRightValue.push(obj);
          });
          this.updatedChartRight();
        }
      });
    },
    updatedChartLeft() {
      var xName = this.souceDataLeftName;
      // var xName = [
      //   { name: "0-2小时", value: "20.00" },
      //   { name: "2-4小时", value: "10.00" },
      //   { name: "4-6小时", value: "5.00" },
      //   { name: "6-8小时", value: "0.00" },
      //   { name: "8-10小时", value: "0.00" },
      //   { name: "10-12小时", value: "0.00" },
      // ];
      var yValue = this.souceDataLeftValue;
      var colorList = [
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#B620E0", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#E980F8", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#fffe95", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#C4DC2D", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#FFEE7A", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#F7B500", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#AEF2D6", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#30BC74", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#6FDDFF", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#0896FF", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#31a2fa", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#0666e8", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
      ];
      var ar = [];
      xName.forEach((item) => {
        ar.push(`${item.value}`);
      });
      if (ar.every((val) => val == 0)) {
        xName = [
          {
            value: 0,
            name: "",
          },
        ];
        colorList = ["rgba(2, 154, 255, 0.27)"];
      } else {
        colorList = colorList;
        xName = xName;
      }

      const option = {
        title: [
          {
            show: true,
            text: "充电时长",
            textStyle: {
              color: "#B3CCFF",
              fontSize: 25,
              fontWeight: "bold",
            },
            left: "49%",
            top: "50%",
          },
          {
            show: true,
            text: "近7日订单",
            textStyle: {
              color: "#00ECFC",
              fontSize: 18,
            },
            left: "51%",
            top: "37%",
          },
        ],
        legend: {
          orient: "vertical",
          left: "0",
          top: "45%",
          height: 300,
          itemHeight: 10,
          itemWidth: 10,
          textStyle: {
            color: "#fff",
          },
          formatter: (e) => {
            console.log(e, "eeeeeeeeeeeeeeeee");
            var data = option.series[0].data;
            console.log(data, "datadataformatterformatterformatter11111");
            var total = 0;
            var val = 0;
            data.forEach((el) => {
              el.value = el.value * 1;
              total += el.value;
              if (e == el.name) val = el.value;
            });
            return `${e} ${((val / total) * 100).toFixed(2)}%`;
          },
        },
        grid: {
          left: "15%",
          right: "0%",
          bottom: "2%",
          top: "5%",
          containLabel: true,
        },
        series: [
          // {
          //   name: "访问来源",
          //   type: "pie",
          //   hoverAnimation: false,
          //   legendHoverLink: false,
          //   radius: ["55%", "65%"],
          //   left: "22%",
          //   top: "0",
          //   color: [
          //     {
          //       type: "linear",
          //       x: 0,
          //       y: 0,
          //       x2: 0,
          //       y2: 1,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "#B620E0", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#E980F8", // 100% 处的颜色
          //         },
          //       ],
          //       global: false, // 缺省为 false
          //     },
          //     {
          //       type: "linear",
          //       x: 0,
          //       y: 0,
          //       x2: 0,
          //       y2: 1,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "#FFEE7A", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#F7B500", // 100% 处的颜色
          //         },
          //       ],
          //       global: false, // 缺省为 false
          //     },
          //     {
          //       type: "linear",
          //       x: 0,
          //       y: 0,
          //       x2: 0,
          //       y2: 1,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "#AEF2D6", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#30BC74", // 100% 处的颜色
          //         },
          //       ],
          //       global: false, // 缺省为 false
          //     },
          //     {
          //       type: "linear",
          //       x: 0,
          //       y: 0,
          //       x2: 0,
          //       y2: 1,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "#6FDDFF", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#0896FF", // 100% 处的颜色
          //         },
          //       ],
          //       global: false, // 缺省为 false
          //     },
          //     {
          //       type: "linear",
          //       x: 0,
          //       y: 0,
          //       x2: 0,
          //       y2: 1,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "#0070F7", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#0041EC", // 100% 处的颜色
          //         },
          //       ],
          //       global: false, // 缺省为 false
          //     },
          //     {
          //       type: "linear",
          //       x: 0,
          //       y: 0,
          //       x2: 0,
          //       y2: 1,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "#fffe95", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#c1c049", // 100% 处的颜色
          //         },
          //       ],
          //       global: false, // 缺省为 false
          //     },
          //   ],
          //   label: {
          //     show: false,
          //     normal: {
          //       position: "inner",
          //     },
          //   },
          //   labelLine: {
          //     normal: {
          //       show: false,
          //     },
          //   },
          //   tooltip: {
          //     show: true,
          //   },
          //   data: yValue,
          // },
          {
            name: "访问来源",
            type: "pie",
            radius: ["65%", "92%"],
            // radius: ["42%", "55%"],
            left: "22%",
            top: "0",
            color: colorList,
            label: {
              show: false,
              // normal: {
              //   formatter: "{b}\n{d}%",
              // },
            },
            data: xName,
          },
        ],
      };
      this.echartAreaLeft.setOption(option);
    },
    updatedChartRight() {
      var xName = this.souceDataRightName;
      var yValue = this.souceDataRightValue;
      var colorList = [
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#B620E0", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#E980F8", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#FFEE7A", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#F7B500", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#AEF2D6", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#30BC74", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#6FDDFF", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#0896FF", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#31a2fa", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#0666e8", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
      ];
      var ar = [];
      xName.forEach((item) => {
        ar.push(`${item.value}`);
      });
      if (ar.every((val) => val == 0)) {
        xName = [
          {
            value: 0,
            name: "",
          },
        ];
        colorList = ["rgba(2, 154, 255, 0.27)"];
      } else {
        colorList = colorList;
        xName = xName;
      }

      const option = {
        title: [
          {
            show: true,
            text: "最大功率",
            textStyle: {
              color: "#B3CCFF",
              fontSize: 25,
              fontWeight: "bold",
            },
            left: "33.3%",
            top: "50%",
          },
          {
            show: true,
            text: "近7日充电",
            textStyle: {
              color: "#00ECFC",
              fontSize: 18,
            },
            left: "35%",
            top: "37%",
          },
        ],
        legend: {
          orient: "vertical",
          right: "5%",
          top: "50%",
          height: 300,
          itemHeight: 10,
          itemWidth: 10,
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "15%",
          right: "0%",
          bottom: "2%",
          top: "5%",
          containLabel: true,
        },
        series: [
          // {
          //   name: "访问来源",
          //   type: "pie",
          //   hoverAnimation: false,
          //   legendHoverLink: false,
          //   radius: ["55%", "65%"],
          //   right: "10%",
          //   top: "0",
          //   color: [
          //   {
          //       type: "linear",
          //       x: 0,
          //       y: 0,
          //       x2: 0,
          //       y2: 1,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "#B620E0", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#E980F8", // 100% 处的颜色
          //         },
          //       ],
          //       global: false, // 缺省为 false
          //     },
          //     {
          //       type: "linear",
          //       x: 0,
          //       y: 0,
          //       x2: 0,
          //       y2: 1,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "#FFEE7A", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#F7B500", // 100% 处的颜色
          //         },
          //       ],
          //       global: false, // 缺省为 false
          //     },
          //     {
          //       type: "linear",
          //       x: 0,
          //       y: 0,
          //       x2: 0,
          //       y2: 1,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "#AEF2D6", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#30BC74", // 100% 处的颜色
          //         },
          //       ],
          //       global: false, // 缺省为 false
          //     },
          //     {
          //       type: "linear",
          //       x: 0,
          //       y: 0,
          //       x2: 0,
          //       y2: 1,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "#6FDDFF", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#0896FF", // 100% 处的颜色
          //         },
          //       ],
          //       global: false, // 缺省为 false
          //     },
          //     {
          //       type: "linear",
          //       x: 0,
          //       y: 0,
          //       x2: 0,
          //       y2: 1,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "#0070F7", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#0041EC", // 100% 处的颜色
          //         },
          //       ],
          //       global: false, // 缺省为 false
          //     },
          //   ],
          //   label: {
          //     show: false,
          //     normal: {
          //       position: "inner",
          //     },
          //   },
          //   labelLine: {
          //     normal: {
          //       show: false,
          //     },
          //   },
          //   tooltip: {
          //     show: true,
          //   },
          //   data: yValue,
          // },
          {
            name: "访问来源",
            type: "pie",
            radius: ["65%", "92%"],
            // radius: ["42%", "55%"],
            right: "10%",
            top: "0",
            color: colorList,
            label: {
              show: false,
              // normal: {
              //   formatter: "{b}\n{d}%",
              // },
            },
            data: xName,
          },
        ],
      };
      this.echartAreaRight.setOption(option);
    },
  },
};
</script>
<style lang="scss" scoped>
#center-1 {
  width: 100%;
  .first {
    display: flex;
    justify-content: center;
    text-align: center;
    margin-bottom: 28px;
    .word {
      font-size: 20px;
      font-weight: bold;
      color: #75b8ff;
      line-height: 80px;
      letter-spacing: 4px;
      margin: 0 20px;
    }
    .sum-num {
      display: flex;
      justify-content: space-around;
      line-height: 80px;
    }
    .fill-bg {
      width: 60px;
      height: 80px;
      background: url("../../assets/pgzl-num-bg.png");
      background-size: 100% 100%;
      font-size: 40px;
      font-weight: bold;
      .num-clor {
        color: #00ecfc;
        text-shadow: 0px 2px 12px rgba(255, 187, 0, 0.44);
        background: linear-gradient(180deg, #fff8c8 0%, #f7b500 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .color-bg {
      font-size: 40px;
      font-weight: bold;
      color: #75b8ff;
    }
  }

  .row {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .row-flex {
    display: grid;
    grid-template-columns: 50% 50%;
  }
  .row-item {
    text-align: center;
    .num {
      font-size: 20px;
      color: #fff;
      margin-bottom: 7px;
    }
    .tip {
      font-size: 12px;
      color: #00ecfc;
    }
    .img {
      width: 100%;
      height: 70px;
      img {
        width: 80px;
        height: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/bicycle-system/option2.vue